import { LI, UL } from "../../../../AbstractElements";
import { SQUARE_GROUP_DATA } from "../../../../Data/Widgets/GeneralWidgets";

const SquareGroup = () => {
  return (
    <UL className="square-group simple-list border-0">
      {SQUARE_GROUP_DATA.map((data, index) => (
        <LI key={index} className={`${data} rounded-0 border-0`}></LI>
      ))}
    </UL>
  );
};

export default SquareGroup;
